import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from '../../app/LanguageContext';
import {
  syncSellingPriceTotalFromUnit,
  syncSellingPriceUnitFromTotal,
} from './priceSimulatorMetadata';

const nf = (v) => {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export default function SellingPriceFields({ product, onProductChange, CurrencyFieldComponent }) {
  const { translate } = useTranslation();
  const quantity = Math.max(1, parseInt(product.quantity, 10) || 1);
  const totalValue = nf(product.selling_price_total) > 0 ? nf(product.selling_price_total) : 0;
  const unitValue = nf(product.selling_price_unit) > 0 ? nf(product.selling_price_unit) : 0;

  const handleTotalChange = (v) => {
    const synced = syncSellingPriceUnitFromTotal(v, quantity);
    onProductChange((p) => ({ ...p, ...synced }));
  };

  const handleUnitChange = (v) => {
    const synced = syncSellingPriceTotalFromUnit(v, quantity);
    onProductChange((p) => ({ ...p, ...synced }));
  };

  const Field = CurrencyFieldComponent;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
      <Field
        size="small"
        fullWidth
        label={translate('price_simulate.selling_price')}
        value={totalValue}
        onChange={handleTotalChange}
        sx={{ flex: 1, minWidth: 0 }}
      />
      <Field
        size="small"
        fullWidth
        label={translate('price_simulate.selling_price_unit')}
        value={unitValue}
        onChange={handleUnitChange}
        sx={{ flex: 1, minWidth: 0 }}
      />
    </Stack>
  );
}

export function applyQuantityChangeKeepingUnitPrice(prevProduct, nextQuantity) {
  const q = Math.max(1, parseInt(nextQuantity, 10) || 1);
  const unit = nf(prevProduct.selling_price_unit);
  if (unit > 0) {
    const synced = syncSellingPriceTotalFromUnit(unit, q);
    return { ...prevProduct, quantity: q, ...synced };
  }
  const total = nf(prevProduct.selling_price_total);
  if (total > 0) {
    const synced = syncSellingPriceUnitFromTotal(total, q);
    return { ...prevProduct, quantity: q, ...synced };
  }
  return { ...prevProduct, quantity: q };
}
